export const getDefaultTheme = (): 'light' | 'dark' => {
    if (typeof window === 'undefined') {
        return 'light';
    }

    const themeFromLocalStorage = localStorage.getItem('theme');

    if (themeFromLocalStorage === 'light' || themeFromLocalStorage === 'dark') {
        return themeFromLocalStorage;
    }

    if (
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
        return 'dark';
    }

    return 'light';
};
